/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the Component Sets screen.
 * @export
 */
export const COMPONENT_SETS_DATA_IDS = {
  createSet: `Create a new set button`,
  createSetCancel: `Cancel create a new component set button`,
  createSetConfirm: `Confirm create a new component set button`,
  createSetDescription: `Create component set description form field`,
  createSetForm: `Create component set form`,
  createSetName: `Create component set name form field`,
  createSetWebpath: `Create component set webpath form field`,
  list: `Component set list`,
  listEmptyState: `Component set list empty state`,
  setDescription: `Component set description`,
  setIcon: `Component set icon`,
  setTitle: `Component set title`,
  showMore: `Show more component sets button`,
};

/**
 * The form field ids used in the Component Sets screen.
 * @export
 */
export const COMPONENT_SETS_FORM_IDS = {
  description: `set-description`,
  name: `set-name`,
  webpath: `set-webpath`,
};
